import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';

const Header = ({ title, showBack = true, rightAction }) => {
  const navigate = useNavigate();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        {showBack && (
          <button className={styles.backBtn} onClick={() => navigate(-1)} aria-label="Go back">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="#1A1A1A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
      <span className={styles.title}>{title}</span>
      <div className={styles.right}>
        {rightAction}
      </div>
    </header>
  );
};

export default Header;
